import capitalize from 'lodash/capitalize';

import { ETransactionAction } from 'api/apiTransactions/models';
import { ETransactionsStatuses } from 'api/apiTransactions/models/ITransactionItem';
import { pairBots, solPairBots } from 'types/bots';
import { ECexOrderBot, ECexOrderSide, ECexOrderStatus } from 'types/cex/orders';
import { IFilterColorSelectItem } from 'types/filters/common';

export enum EFilterColor {
  blue_1 = 'rgb(129, 177, 255)',
  blue_2 = 'rgb(4, 169, 244)',
  blue_3 = 'rgb(2, 188, 212)',
  blue_4 = 'rgb(2, 49, 232)',
  blue_5 = 'rgb(48, 130, 183)',
  blue_6 = 'rgb(59, 130, 246)',
  blue_7 = 'rgb(0, 102, 204)',
  violet_1 = 'rgb(128, 119, 241)',
  violet_2 = 'rgb(106, 133, 255)',
  violet_3 = 'rgb(191, 85, 236)',
  green_1 = 'rgb(27, 188, 156)',
  green_2 = 'rgb(46, 205, 111)',
  green_3 = 'rgb(100, 224, 165)',
  pink_1 = 'rgb(234, 128, 252)',
  pink_2 = 'rgb(249, 0, 234)',
  pink_3 = 'rgb(255, 127, 171)',
  pink_4 = 'rgb(242, 29, 135)',
  brown_1 = 'rgb(128, 0, 0)',
  yellow_1 = 'rgb(243, 243, 30)',
  orange_1 = 'rgb(230, 81, 0)',
  orange_2 = 'rgb(175, 126, 46)',
  orange_3 = 'rgb(172, 150, 0)',
  orange_4 = 'rgb(242, 185, 29)',
  red_1 = 'rgb(229, 0, 0)',
  red_2 = 'rgb(206, 73, 102)',
}

export const TX_ACTIONS: IFilterColorSelectItem[] = [
  {
    value: ETransactionAction.ActionAFRBuy,
    label: ETransactionAction.ActionAFRBuy,
    color: EFilterColor.blue_1,
  },
  {
    value: ETransactionAction.ActionAFRSell,
    label: ETransactionAction.ActionAFRSell,
    color: EFilterColor.blue_2,
  },
  {
    value: ETransactionAction.ActionAddLiquidity,
    label: ETransactionAction.ActionAddLiquidity,
    color: EFilterColor.blue_3,
  },
  {
    value: ETransactionAction.ActionApproval,
    label: ETransactionAction.ActionApproval,
    color: EFilterColor.blue_4,
  },
  {
    value: ETransactionAction.ActionBaseBuyEth,
    label: ETransactionAction.ActionBaseBuyEth,
    color: EFilterColor.brown_1,
  },
  {
    value: ETransactionAction.ActionBaseBuyEthHolder,
    label: ETransactionAction.ActionBaseBuyEthHolder,
    color: EFilterColor.pink_1,
  },
  {
    value: ETransactionAction.ActionBaseSellEth,
    label: ETransactionAction.ActionBaseSellEth,
    color: EFilterColor.pink_2,
  },
  {
    value: ETransactionAction.ActionBulkBuy,
    label: ETransactionAction.ActionBulkBuy,
    color: EFilterColor.violet_1,
  },
  {
    value: ETransactionAction.ActionBulkBuyMempool,
    label: ETransactionAction.ActionBulkBuyMempool,
    color: EFilterColor.violet_2,
  },
  {
    value: ETransactionAction.ActionBulkSell,
    label: ETransactionAction.ActionBulkSell,
    color: EFilterColor.violet_3,
  },
  {
    value: ETransactionAction.ActionBulkSellMempool,
    label: ETransactionAction.ActionBulkSellMempool,
    color: EFilterColor.pink_3,
  },
  {
    value: ETransactionAction.ActionBuy,
    label: ETransactionAction.ActionBuy,
    color: EFilterColor.green_3,
  },
  {
    value: ETransactionAction.ActionDeposit,
    label: ETransactionAction.ActionDeposit,
    color: EFilterColor.orange_1,
  },
  {
    value: ETransactionAction.ActionQuoteBuyEthHolder,
    label: ETransactionAction.ActionQuoteBuyEthHolder,
    color: EFilterColor.green_2,
  },
  {
    value: ETransactionAction.ActionQuoteSellEth,
    label: ETransactionAction.ActionQuoteSellEth,
    color: EFilterColor.red_1,
  },
  {
    value: ETransactionAction.ActionRemoveLiquidity,
    label: ETransactionAction.ActionRemoveLiquidity,
    color: EFilterColor.blue_5,
  },
  {
    value: ETransactionAction.ActionSell,
    label: ETransactionAction.ActionSell,
    color: EFilterColor.red_2,
  },
  {
    value: ETransactionAction.ActionWithdrawal,
    label: ETransactionAction.ActionWithdrawal,
    color: EFilterColor.orange_3,
  },
];

export const TX_STATUSES: IFilterColorSelectItem[] = [
  {
    value: ETransactionsStatuses.Canceled,
    label: capitalize(ETransactionsStatuses.Canceled),
    color: EFilterColor.blue_6,
  },
  {
    value: ETransactionsStatuses.Error,
    label: capitalize(ETransactionsStatuses.Error),
    color: EFilterColor.red_1,
  },
  {
    value: ETransactionsStatuses.Failed,
    label: capitalize(ETransactionsStatuses.Failed),
    color: EFilterColor.pink_4,
  },
  {
    value: ETransactionsStatuses.Pending,
    label: capitalize(ETransactionsStatuses.Pending),
    color: EFilterColor.orange_4,
  },
  {
    value: ETransactionsStatuses.Processing,
    label: capitalize(ETransactionsStatuses.Processing),
    color: EFilterColor.yellow_1,
  },
  {
    value: ETransactionsStatuses.Successful,
    label: capitalize(ETransactionsStatuses.Successful),
    color: EFilterColor.green_2,
  },
];

export const ORDER_SIDE = [
  {
    value: ECexOrderSide.buy,
    label: capitalize(ECexOrderSide.buy),
    color: EFilterColor.green_2,
  },
  {
    value: ECexOrderSide.sell,
    label: capitalize(ECexOrderSide.sell),
    color: EFilterColor.red_1,
  },
];

export const ORDER_STATUS = [
  {
    value: ECexOrderStatus.active,
    label: capitalize(ECexOrderStatus.active),
    color: EFilterColor.blue_1,
  },
  {
    value: ECexOrderStatus.canceled,
    label: capitalize(ECexOrderStatus.canceled),
    color: EFilterColor.blue_6,
  },
  {
    value: ECexOrderStatus.error,
    label: capitalize(ECexOrderStatus.error),
    color: EFilterColor.red_1,
  },
  {
    value: ECexOrderStatus.filled,
    label: capitalize(ECexOrderStatus.filled),
    color: EFilterColor.green_2,
  },
  {
    value: ECexOrderStatus.success,
    label: capitalize(ECexOrderStatus.success),
    color: EFilterColor.green_2,
  },
  {
    value: ECexOrderStatus.partially_filled,
    label: capitalize(ECexOrderStatus.partially_filled),
    color: EFilterColor.yellow_1,
  },
  {
    value: ECexOrderStatus.failed,
    label: capitalize(ECexOrderStatus.failed),
    color: EFilterColor.red_2,
  },
];

export const ARBITRAGE_STATUS = [
  {
    value: 'failed',
    label: 'Failed',
    color: EFilterColor.red_2,
  },
  {
    value: 'executed',
    label: 'Executed',
    color: EFilterColor.green_2,
  },
];

export const ORDER_BOT = [
  {
    value: ECexOrderBot.organic,
    label: capitalize(ECexOrderBot.organic),
    color: EFilterColor.blue_1,
  },
  {
    value: ECexOrderBot.cm,
    label: capitalize(ECexOrderBot.cm),
    color: EFilterColor.blue_2,
  },
  {
    value: ECexOrderBot.fg,
    label: capitalize(ECexOrderBot.fg),
    color: EFilterColor.blue_3,
  },
  {
    value: ECexOrderBot.order_manager_bot,
    label: capitalize(ECexOrderBot.order_manager_bot),
    color: EFilterColor.violet_1,
  },
  {
    value: ECexOrderBot.orderbook,
    label: capitalize(ECexOrderBot.orderbook),
    color: EFilterColor.blue_4,
  },
  {
    value: ECexOrderBot.dn_orderbook,
    label: 'Delta Neutral OB',
    color: EFilterColor.blue_7,
  },
  {
    value: ECexOrderBot.buysell,
    label: capitalize(ECexOrderBot.buysell),
    color: EFilterColor.blue_5,
  },
  {
    value: ECexOrderBot.buysellv2,
    label: 'Buysell v2',
    color: EFilterColor.violet_1,
  },
  {
    value: ECexOrderBot.orderbook_dynamic,
    label: capitalize(ECexOrderBot.orderbook_dynamic),
    color: EFilterColor.blue_6,
  },
  {
    value: ECexOrderBot.ob_protection,
    label: 'OB protection',
    color: EFilterColor.brown_1,
  },
  {
    value: ECexOrderBot.counter_order,
    label: capitalize(ECexOrderBot.counter_order),
    color: EFilterColor.blue_1,
  },
  {
    value: ECexOrderBot.abuse_protection,
    label: 'Abuse protection',
    color: EFilterColor.blue_2,
  },
  {
    value: ECexOrderBot.arbitrage,
    label: 'Arbitrage',
    color: EFilterColor.blue_3,
  },
  {
    value: ECexOrderBot.unknown,
    label: 'Unknown',
    color: EFilterColor.pink_2,
  },
];

export const DOWNLOAD_TRADES_FIELDS = [
  'id',
  'created_at',
  'cex_order_id',
  'cex_trade_id',
  'base_amount',
  'quote_amount',
  'base_fee',
  'quote_fee',
  'price',
  'pair_id',
  'account_id',
  'side',
  'bot',
  'is_maker',
] as const;

export const DOWNLOAD_ORDERS_FIELDS = [
  'id',
  'created_at',
  'sent_at',
  'pair_id',
  'bid',
  'bid_size',
  'ask',
  'ask_size',
  'bot',
  'side',
  'status',
  'time_in_force',
  'base_amount',
  'fact_base_amount',
  'quote_amount',
  'fact_quote_amount',
  'fact_base_fee',
  'fact_quote_fee',
  'price',
  'fact_price',
  'amount_usd',
  'cex_order_id',
  'account_id',
] as const;

export const DOWNLOAD_TRADES_TESTNET_FIELDS = [
  'exchange_order_id',
  'qty',
  'quote_qty',
  'commission',
  'commission_asset',
  'time',
] as const;

export const DOWNLOAD_ORDERS_TESTNET_FIELDS = [
  'exchange_order_id',
  'type',
  'orig_qty',
  'executed_qty',
  'time',
  'update_time',
] as const;

export const getConnectedBot = () =>
  pairBots.map(bot => {
    return {
      value: bot.id.toString(),
      label: capitalize(bot.description),
      color: EFilterColor.blue_1,
    };
  });

export const getConnectedSolBot = () =>
  solPairBots.map(bot => {
    return {
      value: bot.id.toString(),
      label: capitalize(bot.description),
      color: EFilterColor.blue_1,
    };
  });

// Lazy-loaded constants to avoid circular dependency
let _CONNECTED_BOT: ReturnType<typeof getConnectedBot> | null = null;
let _CONNECTED_SOL_BOT: ReturnType<typeof getConnectedSolBot> | null = null;

export const CONNECTED_BOT = new Proxy([] as ReturnType<typeof getConnectedBot>, {
  get(_target, prop) {
    if (!_CONNECTED_BOT) {
      _CONNECTED_BOT = getConnectedBot();
    }
    return Reflect.get(_CONNECTED_BOT, prop);
  },
  ownKeys() {
    if (!_CONNECTED_BOT) {
      _CONNECTED_BOT = getConnectedBot();
    }
    return Reflect.ownKeys(_CONNECTED_BOT);
  },
  getOwnPropertyDescriptor(_target, prop) {
    if (!_CONNECTED_BOT) {
      _CONNECTED_BOT = getConnectedBot();
    }
    return Reflect.getOwnPropertyDescriptor(_CONNECTED_BOT, prop);
  },
});

export const CONNECTED_SOL_BOT = new Proxy([] as ReturnType<typeof getConnectedSolBot>, {
  get(_target, prop) {
    if (!_CONNECTED_SOL_BOT) {
      _CONNECTED_SOL_BOT = getConnectedSolBot();
    }
    return Reflect.get(_CONNECTED_SOL_BOT, prop);
  },
  ownKeys() {
    if (!_CONNECTED_SOL_BOT) {
      _CONNECTED_SOL_BOT = getConnectedSolBot();
    }
    return Reflect.ownKeys(_CONNECTED_SOL_BOT);
  },
  getOwnPropertyDescriptor(_target, prop) {
    if (!_CONNECTED_SOL_BOT) {
      _CONNECTED_SOL_BOT = getConnectedSolBot();
    }
    return Reflect.getOwnPropertyDescriptor(_CONNECTED_SOL_BOT, prop);
  },
});
